import { useRef } from 'react';
import { Button } from '@/components/V3/Button';
import ShareIcon from '@/assets/icons/V3/NewsShareIcon_1.svg?react';
import { motion } from 'framer-motion';
import useWebview from '@/hooks/V3/useWebview';
import { logEvent } from '@/etc/firebase';
import { useParams } from 'react-router-dom';

interface NewsShareButtonProps {
  variant?: 'Secondary' | 'Solid';
}

const NewsShareButton = ({ variant }: NewsShareButtonProps) => {
  const { postMessage } = useWebview();
  const { group } = useParams(); // apage, bpage 구분

  const hasLoggedRef = useRef(false); // 로그 중복 방지

  const handleShare = () => {
    const shareUrl =
      group === 'apage'
        ? 'https://sellerbox.onelink.me/S4GA/newsShareA'
        : 'https://sellerbox.onelink.me/S4GA/newsShareB';

    postMessage({
      action: 'requestAppShare',
      data: shareUrl,
    });

    if (!hasLoggedRef.current) {
      logEvent('click_news_share_button', {
        targetPage: group,
      });
      hasLoggedRef.current = true;
    }
  };

  return (
    <motion.div layoutId="shareButton">
      <Button
        variant={variant}
        onClick={handleShare}
        className="line-clamp-1 flex h-[26px] w-fit items-center gap-[2px] rounded-[8px] px-2  py-[5px] Body5M14"
      >
        공유하기
        <ShareIcon />
      </Button>
    </motion.div>
  );
};

export default NewsShareButton;
